module.exports = __webpack_public_path__ + "media/customizations/sienna/logo-new-6eee3628f81c4c2ae89a088ef857e0cf.png";